import { render, staticRenderFns } from "./NotificationPanelItem.vue?vue&type=template&id=3417abbe&scoped=true"
import script from "./NotificationPanelItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./NotificationPanelItem.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./NotificationPanelItem.vue?vue&type=style&index=0&id=3417abbe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3417abbe",
  null
  
)

export default component.exports